import React from 'react';

import PropTypes from 'prop-types';
import qs from 'query-string';
import uuidV4 from 'uuid/v4';

import { SearchResult } from 'wanderu-component-search-result';
import { Section, Typography, WDSButton } from 'wanderu-components';
import { SnowplowService } from 'wanderu-service-analytics';
import { buildSearchUrlPath } from 'wanderu-utils';

import { TripCardSkeleton } from './TripCardSkeleton/TripCardSkeleton';
import events from './events';

import styles from './Trips.scss';

export const Trips = ({
    history,
    isLoading,
    locale,
    searchParams,
    trips,
}) => {
    const batchId = uuidV4();
    SnowplowService.setBatchId(batchId);

    const {
        departPlaceId,
        arrivePlaceId,
    } = searchParams;

    const queries = qs.parse(history?.location?.search || '');
    const queryString = `?${qs.stringify({
        ...queries,
        dpid: arrivePlaceId,
        opid: departPlaceId,
    })}`;
    const searchUrl = buildSearchUrlPath({ ...searchParams, departDate: new Date() }, queries);

    const onClick = () => {
        history.push(`/en-us${searchUrl}`);
    };

    const onSelect = (tripId, position) => {
        const trip = trips[position];
        const price = Object.values(trip?.pricing?.[0])?.[0];

        events.tripSelected({
            batchId,
            count: trips.length,
            position,
            price,
            tripId,
        });

        history.push(`/${locale}/tripsummary/${tripId}/${queryString}`);
    };

    return (
        <Section className={styles.section} classes={{ content: styles.content }}>
            <div className={styles.title}>
                <Typography variant="subtitle">
                    Today&apos;s Top Tickets
                    <span className={styles.hideSmall}>
                        &bull;
                        <WDSButton
                            className={styles.viewAllText}
                            onClick={onClick}
                            variant="unstyled"
                        >
                            View all
                        </WDSButton>
                    </span>
                </Typography>
            </div>
            <div className={styles.trips}>
                {isLoading && Array.from(Array(3)).map((_, index) => <TripCardSkeleton key={`trip-card-skeleton-${index}`} />)}
                {trips.slice(0, 3).map((trip, index) => (
                    <SearchResult
                        {...trip}
                        key={trip.tripId}
                        onSelect={(tripId) => onSelect(tripId, index)}
                        variant="travelOptions"
                    />
                ))}

                <WDSButton
                    className={styles.hideLarge}
                    color="secondary"
                    onClick={onClick}
                    fullWidth
                >
                    View All Trips Today
                </WDSButton>
            </div>
        </Section>
    );
};

Trips.propTypes = {
    history: PropTypes.shape({
        location: PropTypes.shape({
            search: PropTypes.string,
        }),
        push: PropTypes.func.isRequired,
    }).isRequired,
    isLoading: PropTypes.bool,
    locale: PropTypes.string.isRequired,
    searchParams: PropTypes.shape({
        arrivePlace: PropTypes.string,
        arrivePlaceId: PropTypes.string,
        departDate: PropTypes.string,
        departPlace: PropTypes.string,
        departPlaceId: PropTypes.string,
        returnDate: PropTypes.string,
    }),
    trips: PropTypes.arrayOf(
        PropTypes.shape({
            carrierCode: PropTypes.string,
            pricing: PropTypes.array,
            tripId: PropTypes.string,
        })
    ),
};
